<app-nav-context-header
    [expanded]="expanded()"
    [backRoute]="quotesListRoute()"
    backLabel="HEADER.ALL_QUOTES"
    [hideIdentity]="true" />

<!-- Overview -->
<ul class="yllw-sidenav__menu">
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="baseRoute()" routerLinkActive="yllw-sidenav__item-link--active"
            [routerLinkActiveOptions]="{ paths: 'exact', matrixParams: 'ignored', queryParams: 'ignored', fragment: 'ignored' }" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.OVERVIEW' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-th-large yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.OVERVIEW" | translate }}</span> }
        </a>
    </li>
</ul>

<!-- QUOTE section -->
<div class="yllw-sidenav__section-header" [class.yllw-sidenav__section-header--collapsed]="!expanded()">
    @if (expanded()) {
        <span class="yllw-sidenav__section-text">{{ "QUOTE.DETAIL.SECTIONS.QUOTE" | translate }}</span>
    }
</div>
<ul class="yllw-sidenav__menu">
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('quote-info')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.QUOTE_INFO' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-info-circle yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.QUOTE_INFO" | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('billing')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.BILLING' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-credit-card yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.BILLING" | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('delivery')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.DELIVERY' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-warehouse yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.DELIVERY" | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('notes')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.NOTES' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-file-edit yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.NOTES" | translate }}</span> }
        </a>
    </li>
    @if (isSubscription()) {
        <li class="yllw-sidenav__item">
            <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('drawing')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
                [pTooltip]="'QUOTE.DETAIL.TABS.DRAWING' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
                <i class="pi pi-pencil yllw-sidenav__item-icon"></i>
                @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.DRAWING" | translate }}</span> }
            </a>
        </li>
    }
</ul>

<!-- VERSION section -->
<div class="yllw-sidenav__section-header" [class.yllw-sidenav__section-header--collapsed]="!expanded()">
    @if (expanded()) {
        <span class="yllw-sidenav__version-selector">
            <span class="yllw-sidenav__section-text">{{ "QUOTE.DETAIL.SECTIONS.VERSION" | translate }}</span>
            <i class="pi yllw-sidenav__lock-icon"
                [class.pi-lock]="isVersionLocked()" [class.pi-lock-open]="!isVersionLocked()"
                [class.yllw-sidenav__lock-icon--locked]="isVersionLocked()"
                [pTooltip]="versionLockTooltip() | translate" tooltipPosition="right" [tooltipDisabled]="!versionLockTooltip()"></i>
            @if (isSubscription()) {
                <p-tag class="yllw-sidenav__status-tag" [value]="versionStatusLabel() | translate"
                    [icon]="versionStatusIcon()" [severity]="versionStatusSeverity()" [styleClass]="'p-tag-' + versionStatusSeverity()" [rounded]="true" />
            }
        </span>
    }
</div>
<ul class="yllw-sidenav__menu">
    @if (isSubscription()) {
        <li class="yllw-sidenav__item">
            <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('startup-info')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
                [pTooltip]="'QUOTE.DETAIL.TABS.STARTUP_INFO' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
                <i class="pi pi-stopwatch yllw-sidenav__item-icon"></i>
                @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.STARTUP_INFO" | translate }}</span> }
            </a>
        </li>
    }
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('articles')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="articlesLabel | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-box yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ articlesLabel | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('services')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="(isSubscription() ? 'QUOTE.DETAIL.TABS.PRICING_NO_KICKBACK' : 'QUOTE.DETAIL.TABS.PRICING') | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-users yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ (isSubscription() ? 'QUOTE.DETAIL.TABS.PRICING_NO_KICKBACK' : 'QUOTE.DETAIL.TABS.PRICING') | translate }}</span> }
        </a>
    </li>
    @if (isSubscription()) {
        <li class="yllw-sidenav__item">
            <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('plants')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
                [pTooltip]="'QUOTE.DETAIL.TABS.PLANTS' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
                <i class="pi pi-sun yllw-sidenav__item-icon"></i>
                @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.PLANTS" | translate }}</span> }
            </a>
        </li>
    }
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('freight')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.FREIGHT' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-truck yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.FREIGHT" | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('brand-information')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.BRAND_INFORMATION' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-barcode yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.BRAND_INFORMATION" | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('preview')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.PREVIEW' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-file-pdf yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.PREVIEW" | translate }}</span> }
        </a>
    </li>
</ul>

<!-- OTHER section -->
<div class="yllw-sidenav__section-header" [class.yllw-sidenav__section-header--collapsed]="!expanded()">
    @if (expanded()) {
        <span class="yllw-sidenav__section-text">{{ "QUOTE.DETAIL.SECTIONS.OTHER" | translate }}</span>
    }
</div>
<ul class="yllw-sidenav__menu">
    @if (isSubscription()) {
        <li class="yllw-sidenav__item">
            <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('terms')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
                [pTooltip]="'QUOTE.DETAIL.TABS.TERMS' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
                <i class="pi pi-file-check yllw-sidenav__item-icon"></i>
                @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.TERMS" | translate }}</span> }
            </a>
        </li>
    }
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('inquiries')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.INQUIRIES' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-send yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.INQUIRIES" | translate }}</span> }
        </a>
    </li>
    <li class="yllw-sidenav__item">
        <a class="yllw-sidenav__item-link" [routerLink]="tabRoute('versions')" routerLinkActive="yllw-sidenav__item-link--active" pRipple
            [pTooltip]="'QUOTE.DETAIL.TABS.VERSIONS' | translate" tooltipPosition="right" [tooltipDisabled]="expanded()">
            <i class="pi pi-history yllw-sidenav__item-icon"></i>
            @if (expanded()) { <span class="yllw-sidenav__item-text">{{ "QUOTE.DETAIL.TABS.VERSIONS" | translate }}</span> }
        </a>
    </li>
</ul>
